import React from "react";

const PolicyBackButton = () => {
  const goBack = () => {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    window.location.href = "/";
  };

  return (
    <button
      type="button"
      className="policy-close-btn"
      aria-label="Close"
      onClick={goBack}
    >
      Close
    </button>
  );
};

export default PolicyBackButton;
